import { useState } from 'react';
import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Link,
} from '@chakra-ui/react';
import { Link as RouteLink } from 'react-router-dom';
import { useSignUp } from './use-user';
import { UserLayout } from './UserLayout';

export const SignUp = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const { register, loading, error } = useSignUp();

  const submit = async (event: any) => {
    event.preventDefault();
    try {
      await register({
        variables: {
          registerInput: {
            username,
            email,
            password,
            confirmPassword,
          },
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <UserLayout>
      <Box p='2'>
        <Box>
          {error && (
            <Alert status='error' mt='4' borderRadius='4'>
              <AlertIcon />
              <AlertDescription>{error?.message}</AlertDescription>
            </Alert>
          )}
        </Box>
        <Box my={4}>
          <form onSubmit={(e) => submit(e)}>
            <FormControl id='username' isRequired>
              <FormLabel>Username</FormLabel>
              <Input
                onChange={(e) => setUsername(e.target.value.toLowerCase())}
                type='text'
              />
            </FormControl>
            <FormControl id='email' mt='4' isRequired>
              <FormLabel>E-mail</FormLabel>
              <Input onChange={(e) => setEmail(e.target.value)} type='email' />
            </FormControl>
            <FormControl id='password' mt='4' isRequired>
              <FormLabel>Password</FormLabel>
              <Input
                onChange={(e) => setPassword(e.target.value)}
                type='password'
              />
            </FormControl>
            <FormControl id='confirmpassword' mt='4' isRequired>
              <FormLabel>Confirm Password</FormLabel>
              <Input
                onChange={(e) => setConfirmPassword(e.target.value)}
                type='password'
              />
            </FormControl>
            {loading}
            <Button
              isLoading={loading}
              type='submit'
              colorScheme='teal'
              width='full'
              mt='4'
            >
              Submit
            </Button>
            <Box textAlign='center' mt='1'>
              <Link fontSize='xs' as={RouteLink} to='/sign-in'>
                Have an account? Sign In
              </Link>
            </Box>
          </form>
        </Box>
      </Box>
    </UserLayout>
  );
};
